module.exports = __webpack_public_path__ + "static/media/trimex_suprema50.407a46c6.png";